<div [ngClass]="{ 'form-group': field.type === 'ish-checkbox-field' }" class="row">
  @if (props?.title) {
  <div class="col-form-label" [ngClass]="props?.titleClass ? props?.titleClass : dprops?.titleClass">
    {{ props.titleNoTranslate ? props.title : (props.title | translate) }}@if (props?.required &&
    !props?.hideRequiredMarker) {
    <span class="required" aria-hidden="true">*</span>
    }
  </div>
  }
  <div
    class="col-form-label"
    [class.has-error]="showError"
    [ngClass]="[
      props.fieldClass ? props.fieldClass : dprops.fieldClass,
      props.title || props.fieldClass ? '' : dprops.noTitleClass
    ]"
  >
    <div class="form-check" [attr.data-testing-id]="keyString + '-wrapper'">
      <ng-template #fieldComponent />
      <label
        *ngIf="props?.label || props?.tooltip"
        [attr.for]="id"
        class="form-check-label"
        [ngClass]="props.labelClass ? props?.labelClass : dprops?.labelClass"
      >
        @if (props?.label) {
        <span>{{ props?.labelNoTranslate ? props?.label : (props?.label | translate) }}</span>
        } @if (props?.tooltip) {
        <ish-field-tooltip [tooltipInfo]="props?.tooltip" />
        }
      </label>
    </div>
    @if (showError) {
    <ng-container class="invalid-feedback d-block">
      <ish-validation-message [field]="field" class="validation-message" />
    </ng-container>
    }
  </div>
</div>
